import { useState } from "react";
import "../assets/css/app.css";
import MainLogo from "../assets/images/main-logo.png";
import { Link } from "react-router-dom";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import { ArrowCircleRightIcon } from "@phosphor-icons/react";

const PasswordForgot = () => {
    const [email, setEmail] = useState("");
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");
    const [loader, setLoader] = useState(false);

    const handleSubmit = () => {
        setLoader(true);

        axios
            .post(import.meta.env.VITE_UPA_API_HOST + "login/forgot-password", {
                email: email,
            })
            .then((response) => {
                setError("");
                setEmail("");
                setLoader(false);
                setMessage(response.data.message);
            })
            .catch((error) => {
                setLoader(false);
                setError(error.response.data.message);
            });
    };

    return (
        <div className="main-login">
            <div className="login-background" />
            <div className="login-container">
                <div className="login-form">
                    <div className="img-container">
                        <img src={MainLogo} alt="logo" width={180} />
                    </div>
                    <div className="c-modal-content">
                        <div className="login-header">
                            <h1>Mot de passe oublié</h1>
                            <p className="welcome-message">Renseignez votre adresse email</p>
                        </div>
                        {error ? <p className="login-error">{error}</p> : null}
                        {message ? <p className="login-message">{message}</p> : null}
                        <div className="custom__modal-group">
                            <label className="email">
                                Email <span className="required-asterisk">*</span>
                            </label>
                            <input
                                type="email"
                                placeholder="Saisissez votre adresse email"
                                value={email}
                                onChange={(e) => {
                                    setEmail(e.target.value);
                                    setError("");
                                }}
                                className="classic-input"
                            />
                        </div>
                        <Link to="/login" className="forgot-password">
                            Retour à la connexion
                        </Link>
                        <div className="login-button-container">
                            {loader ? (
                                <button className="button-large blue-button" disabled>
                                    <CircularProgress size={20} className="white-loader" />
                                </button>
                            ) : (
                                <button className="button-large blue-button" type="submit" onClick={handleSubmit}>
                                    <span>Envoyer</span>
                                    <ArrowCircleRightIcon size={16} weight="bold" />
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PasswordForgot;
